import withProps from 'hooks/withProps';
import Icon from 'components/Icon';

export const product = [
  {
    id: 'product-0',
    href: '/marketplace',
    Icon: Icon.Marketplace,
    title: 'Marketplace',
    description: 'Everything your lab needs in one place.',
  },
  {
    id: 'product-1',
    href: '/shared-cart',
    Icon: Icon.Egg1,
    title: 'Shared Cart',
    description: 'Streamlined requisitioning.',
  },
  {
    id: 'product-4',
    href: '/curator',
    Icon: Icon.FilterColor,
    title: 'Curator',
    description: 'Curated supplies from product experts.',
  },
  {
    id: 'product-3',
    href: '/science-samples',
    Icon: Icon.Dna,
    title: 'Science Samples',
    description: 'Discover better, cost effective supplies.',
  },
];

export const enterprise = [
  {
    id: 'enterprise-0',
    href: '/',
    Icon: Icon.Bulb,
    title: 'Solutions',
    description: 'Supercharge your organization’s eProcurement.',
  },
  {
    id: 'enterprise-1',
    href: '/',
    Icon: Icon.Cog,
    title: 'Intergations',
    description: 'Integrate your existing ERP & eProcurement.',
  },
  {
    id: 'enterprise-2',
    href: '/',
    Icon: Icon.CogInBox,
    title: 'Onboarding',
    description: 'Drive end user option with ease.',
  },
];

export const company = [
  {
    id: 'company-0',
    href: '/about',
    Icon: Icon.Dna,
    title: 'About',
    description: 'The company, our mission and our values.',
  },
  {
    id: 'company-1',
    href: '/supplier-partners',
    Icon: Icon.City,
    title: 'Supplier Partners',
    description: 'Our niche and industry leading suppliers.',
  },
  {
    id: 'company-2',
    href: '/open-positions',
    Icon: withProps(Icon.Case, { color: 'primary.dark' }),
    title: 'Careers',
    description: 'Join us. Be yourself. Drive our mission.',
  },
  {
    id: 'company-3',
    href: '/blogs',
    Icon: Icon.Blog,
    title: 'Blog',
    description: 'Company blog.',
  },
  {
    id: 'company-4',
    href: '/newsroom',
    Icon: Icon.PaperSheet4,
    title: 'Newsroom',
    description: 'Get the latest news and updates.',
  },
  {
    id: 'company-5',
    href: '/',
    Icon: Icon.Layout,
    title: 'Press Kit',
    description: 'Access brand assets.',
  },
];

const config = { product, enterprise, company };

export default config;
